import script from "./ReceitasDespesas.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceitasDespesas.vue?vue&type=script&setup=true&lang=js"

import "./ReceitasDespesas.vue?vue&type=style&index=0&id=4994180f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4994180f"]])

export default __exports__